import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CloudinaryContext } from 'cloudinary-react';
import MainAppBar from 'components/layout/MainAppBar';
import Routes from 'routes';

import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme } from '@material-ui/core/styles';
import { withAuthUser } from 'components/Session';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import { ParallaxProvider } from 'react-scroll-parallax';
import ScrollToTop from './ScrollToTop';
import { StripeProvider } from 'react-stripe-elements';
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#d46f2d'
    },
    secondary: {
      main: '#02A9B3'
    }
  },
  // @ts-ignore
  status: {
    success: '#43a047'
  }
});

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  mainContainer: {
    marginTop: 64,
    paddingLeft: 0,
    paddingRight: 0,
    [theme.breakpoints.down('xs')]: {
      marginTop: 56
    }
  }
});
const App = () => {
  const classes = useStyles({})
    ;
  return (
    <CloudinaryContext cloudName="bodyf1rst">
      <ParallaxProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <StripeProvider apiKey="pk_test_d7DbBcfuEjDUEtR3pJFplknm00rTuTDl2d">
            <Router>
              <ScrollToTop>
                <div className={classes.root}>
                  <MainAppBar />
                  <Container maxWidth="lg" className={classes.mainContainer}>
                    <Routes />
                  </Container>
                </div>
              </ScrollToTop>
            </Router>
          </StripeProvider>
        </ThemeProvider>
      </ParallaxProvider>
    </CloudinaryContext>
  );
};

export default withAuthUser(App);
